import {
  OrderListIngredient,
  OrderListIngredientRecipe,
  OrderListProductRecipe,
} from "../../models/orderListModels";
import { QueryKeys } from "../../shared/react-query/queryKeys";
import { OrderListDataEndpoint } from "./hooks/useOrderListMasterData";

export interface OrderListDatasetDefinition<T> extends OrderListDataEndpoint {
  label: string;
  description: string;
  expectedFileName: string;
  type?: T;
}

export const ORDER_LIST_DATASETS = {
  ingredients: {
    label: "Ingredients",
    description: "Ingredient catalogue, category and purchase type",
    expectedFileName: "orderlist_ingredients.json",
    queryKey: QueryKeys.ORDER_LIST_INGREDIENTS,
    getPath: "/admin/GetOrderListIngredients",
    setPath: "/admin/SetOrderListIngredients",
  } as OrderListDatasetDefinition<OrderListIngredient>,
  recipes: {
    label: "Product recipes",
    description: "PLU recipes and direct ingredient quantities",
    expectedFileName: "orderlist_recipes.json",
    queryKey: QueryKeys.ORDER_LIST_RECIPES,
    getPath: "/admin/GetOrderListRecipes",
    setPath: "/admin/SetOrderListRecipes",
  } as OrderListDatasetDefinition<OrderListProductRecipe>,
  ingredientRecipes: {
    label: "Ingredient recipes",
    description: "Made In Store parent and child ingredient quantities",
    expectedFileName: "orderlist_ingredient_recipes.json",
    queryKey: QueryKeys.ORDER_LIST_INGREDIENT_RECIPES,
    getPath: "/admin/GetOrderListIngredientRecipes",
    setPath: "/admin/SetOrderListIngredientRecipes",
  } as OrderListDatasetDefinition<OrderListIngredientRecipe>,
};